import { ThProps } from 'app/common/ui-components/table'

import { Entity } from './types'

export const headerCellsProps: Record<string, Partial<ThProps>> = {
  [Entity.Title]: { alignLeft: true, width: 220 },
  [Entity.Date]: { alignCenter: true },
  [Entity.Total]: { alignRight: true, width: 130 },
}

export const createHeaderCellsProps = () => {
  return new Proxy(headerCellsProps, {
    get: function (target, property) {
      const res = target[property as string]
      if (!res) {
        return headerCellsProps[Entity.Date]
      }
      return res || {}
    },
  })
}
